import axios from "axios";

const deleteGig = async (token, tourId, gigId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/gigs/${gigId}`;
  try {
    const response = await axios.delete(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};

export default deleteGig;
